import React from 'react';
import { connect } from 'react-redux';
import SearchBar from './SearchBar';
import FilterBar from './FilterBar';
import FeedbackDetailBar from './FeedbackDetailBar';
import FeedbackInbox from './FeedbackInbox';
import FeedbackDetail from './FeedbackDetail';
import Modal from '../Modal';
import { setSelectedFeedback, ajaxFeedback, setFilterTimeframe } from '../redux/FeedbackRedux';

class HistoryV2 extends React.Component {
    constructor(props) {
        super(props);
        this.state = { showChat: false };
        this.toggleChat = this.toggleChat.bind(this)
        if (this.props.state.selected_feedback) {
            this.props.dispatch(setSelectedFeedback(this.props.state.selected_feedback));
            this.props.dispatch(ajaxFeedback(this.props.state.selected_feedback));
            this.props.dispatch(setFilterTimeframe("lifetime"));
        }
    }

    toggleChat() {
        this.setState({ showChat: !this.state.showChat })
    }

    render() {
        return (
            <>
                {
                    !this.props.state.feedback_detail ?
                        <SearchBar />
                        :
                        null
                }
                {this.props.state.feedback_detail ?
                    <FeedbackDetailBar toggleChat={this.toggleChat} showChat={this.state.showChat} />
                    :
                    <FilterBar />
                }
                {this.props.state.feedback_detail ?
                    <FeedbackDetail toggleChat={this.toggleChat} showChat={this.state.showChat} />
                    :
                    <FeedbackInbox toggleChat={this.toggleChat} showChat={this.state.showChat} />
                }
                {/* Bottom Bar */}
                {
                    !this.props.state.feedback_detail &&
                        <FilterBar position="bottom" />
                }

                <Modal modal={this.props.state.modal} />
            </>
        );
    }
}

function mapStateToProps(state) {
    return { state: state }
}

export default connect(mapStateToProps)(HistoryV2);
